<template>
  <div class="pullNewPage">
    <EmptyData
      emptyName="noPullNew"
      v-if="noData"
    />
    <div v-else>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="60"
          @load="onLoad"
        >
          <div
            class="card"
            v-for="(item, index) in groupList"
            :key="index"
            @click="jumpPullPage(item.activityId,item.startTime)"
          >
            <PullNewCard
              :cardDetail="item"
              :nowTime="nowTime"
            />
          </div>
        </van-list>
      </van-pull-refresh>

    </div>
  </div>
</template>
<script>
import PullNewCard from '@/pages/personalCenter/myActivity/pullNew/pullNewCard.vue';
import { reqPullNewList } from '@/api/personal';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { setBaseUrl, replaceHyphens } from '@/utils/tools';

export default {
  components: {
    PullNewCard,
    EmptyData,
  },
  data() {
    return {
      orderParam: {
        pageNum: 1,
        pageSize: 20,
      },

      refreshing: false, // 下拉刷新
      groupList: [],
      finishTotal: 0,
      nowTime: new Date().getTime(),
      loading: false, // 当loading为true时，转圈圈
      finished: false, // 数据是否请求结束，结束会先显示- 没有更多了 -
      noData: false, // 如果没有数据，显示暂无数据

    };
  },
  computed: {

  },
  watch: {

  },
  created() { },
  mounted() {
    this.getPullNewList(this.orderParam);
  },
  destroyed() { },
  methods: {

    async getPullNewList() {
      const res = await reqPullNewList(this.orderParam);
      if (res.code === 0) {
        this.nowTime = res?.currentTime ? res.currentTime : new Date().getTime();
        this.loading = false;
        this.groupList = this.groupList.concat(res.data.data);
        // eslint-disable-next-line
        this.orderParam.pageNum++;
        // 如果没有数据，显示暂无数据
        if (this.groupList.length === 0 && res.data.total === 0) {
          this.noData = true;
        }
        // 如果加载完毕，显示没有更多了
        if (this.groupList.length >= res.data.total) {
          this.finished = true;
        }
      }
    },
    // 列表加载
    onLoad() {
      setTimeout(() => {
        this.getPullNewList();
        this.loading = true;
      }, 500);
    },
    onRefresh() {
      setTimeout(() => {
        // 重新初始化这些属性
        this.refreshing = false;
        this.groupList = [];
        this.orderParam.pageNum = 1;
        this.loading = false;
        this.finished = false;
        this.noData = false;
        // 请求信息
        this.getInfo();
      }, 500);
    },
    // 判断时间点:2022/8/21 之后是新链接 之前是旧
    jumpPullPage(activityId, startTime) {
      const fixedTime = new Date(replaceHyphens('2022-08-21')).getTime();
      let pageUrl = '';
      if (new Date(replaceHyphens(startTime)).getTime() > fixedTime) {
        pageUrl = `/ark/pullnew/home/?activityId=${activityId}`;
      } else {
        pageUrl = `/zt/pullnew/home/?activityId=${activityId}`;
      }

      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}${pageUrl}` },
          false,
        );
      }
      // H5
      window.open(pageUrl);
    },

  },
};
</script>
<style scoped lang="scss">
.pullNewPage {
  width: 100%;
  min-height: calc(100vh - 172px);
  padding-top: 22px;
  padding-bottom: 100px;
  .card {
    margin-bottom: 22px;
  }
}
</style>
